// extracted by mini-css-extract-plugin
module.exports = {"paper":"popup-notification_paper__2vBbP","wrap":"popup-notification_wrap__1T9Xl"};